import phone from '../../images/phone-store.PNG';
import Chat from '../../images/chat_app.PNG';
import spice from '../../images/spiceup.PNG';
const project = [
  {
    title: 'Kings_Mobile',
    logo: phone,
    description:
      'Shop top-tier electronics at KINGS_MOBILE. Browse, buy, and enjoy!',
    skills: ['Next.js', 'Prisma', 'Stripe'],
    demo: 'https://kings-mobile-store.vercel.app/',
    repo: 'https://github.com/okoid721',
  },
  {
    title: 'Easy text',
    logo: Chat,
    description:
      'Connect effortlessly with Easy Text. Experience seamless communication, instant messaging, and endless conversations. Join the conversation now',
    skills: ['react', 'expess', 'node'],
    demo: 'https://chat-full-project.onrender.com/',
    repo: 'https://github.com/okoid721',
  },
  {
    title: 'SPICE_UP',
    logo: spice,
    description:
      'Explore a world of culinary delights with Spice_up. Discover thousands of mouth-watering recipes from around the globe, ranging from quick and easy meals to gourmet dishes. Get inspired, cook with confidence, and delight your taste buds!',
    skills: ['React', 'Node.js', 'MongoDB'],
    demo: 'https://spice-up.vercel.app/',
    repo: 'https://github.com/okoid721',
  },
];

export default project;
